// extracted by mini-css-extract-plugin
module.exports = {"setApartmaibox":"WhatSetsApart_setApartmaibox__YfiLI","setAparttiles":"WhatSetsApart_setAparttiles__IctIt","setSidetext":"WhatSetsApart_setSidetext__v7oXH"};